import { LclWeightBracketPriceMapper } from "./lcl-weight-bracket-price.mapper";
import { LclWeightBracketPriceDict } from "./lcl-weight-bracket-price-dict.type";
import { LclWeightBracketPrice } from "./lcl-weight-bracket-price.model";

export class LclWeightBracketPriceDictMapper {
  public static toDict(data: any = []): LclWeightBracketPriceDict {
    const containers = <LclWeightBracketPriceDict>{};

    if (Array.isArray(data)) {
      data.forEach((containerObject) => {
        containers[containerObject.name] =
          LclWeightBracketPriceMapper.map(containerObject);
      });
    }

    return containers;
  }

  public static toArray(
    data: LclWeightBracketPriceDict,
  ): LclWeightBracketPrice[] {
    return Object.keys(data).map(
      (weightBracketName) =>
        new LclWeightBracketPrice(
          weightBracketName,
          data[weightBracketName].value,
        ),
    );
  }
}
